// hooks/useMenuStatusWatcher.js

import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWindowSize } from 'hooks/useWindowSize';
import {
  menuChangeBehaviourStatus,
  menuChangePlacementStatus,
} from 'layout/nav/main-menu/menuSlice';
import {
  checkBehaviour,
  checkPlacement,
  isDeeplyDiffBehaviourStatus,
  isDeeplyDiffPlacementStatus,
} from 'layout/nav/main-menu/helper';

const useMenuStatusWatcher = () => {
  const dispatch = useDispatch();
  const { width } = useWindowSize();

  const {
    placement,
    behaviour,
    placementStatus,
    behaviourStatus,
    breakpoints,
  } = useSelector((state) => state.menu);

  const getMenuStatus = useCallback(
    (pBreakpoints, pPlacement, pBehaviour) => {
      if (!pBreakpoints) return;

      const placementStatusCB = checkPlacement({
        placement: pPlacement,
        breakpoints: pBreakpoints,
      });

      const behaviourStatusCB = checkBehaviour({
        placement: placementStatusCB.placementHtmlData,
        behaviour: pBehaviour,
        breakpoints: pBreakpoints,
      });

      if (isDeeplyDiffPlacementStatus(placementStatusCB, placementStatus)) {
        dispatch(menuChangePlacementStatus(placementStatusCB));
      }

      if (isDeeplyDiffBehaviourStatus(behaviourStatusCB, behaviourStatus)) {
        dispatch(menuChangeBehaviourStatus(behaviourStatusCB));
      }
    },
    [dispatch, placementStatus, behaviourStatus]
  );

  useEffect(() => {
    if (width && placement && behaviour && breakpoints) {
      getMenuStatus(breakpoints, placement, behaviour);
    }
  }, [width, breakpoints, placement, behaviour, getMenuStatus]);
};

export default useMenuStatusWatcher;